import React from 'react';
import { Link } from 'react-router';
import $ from 'jquery';
import { connect } from 'react-redux';
const { Component } = React;
import css from '../styles/mobile-nav.css';

class MobileNav extends React.Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.state = {
      mobileNavActive: false
    };
  }

  onClick() {
    let newStatus = !this.state.mobileNavActive;
    this.setState({ mobileNavActive: newStatus });

    if (newStatus) {
      $('body').addClass('no-scroll');
    } else {
      $('body').removeClass('no-scroll');
    }

  }

  render() {
    let classNames = ['mobile-nav'];
    if (this.state.mobileNavActive) {
      classNames.push('active');
    }

    let { items } = this.props;

    return (
      <div className={classNames.join(' ')}>
        <div className="mobile-nav__wrap">
          <button className="mobile-nav__hamburger" onClick={this.onClick}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <ul className="mobile-nav__list">
          <li className="mobile-nav__list-item" onClick={this.onClick}><Link to="/">Home</Link></li>
          {items.map((item, i) => <li key={i} className="mobile-nav__list-item" onClick={this.onClick}><Link to={item.path}>{item.label}</Link></li>)}
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    items: state.nav.items
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const MobileNavContainer = connect(mapStateToProps, mapDispatchToProps)(MobileNav);

export {MobileNav, MobileNavContainer};





// WEBPACK FOOTER //
// ./app/screens/App/components/mobile-nav.js